// @ts-nocheck
import * as React from "react";

const Undo: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21">
            <g stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" transform="translate(1, 1)">
                <polyline
                    transform="translate(2.725800, 2.711348) scale(-1, 1) translate(-2.725800, -2.711348) "
                    points="0.216365217 5.19534783 5.23523478 5.22195652 5.21097391 0.20073913"
                />
                <path
                    d="M15.9501739,14.9508783 C12.6006087,18.3012261 7.08947826,18.2198348 3.64052174,14.7708783 C0.191565217,11.3219217 0.110956522,5.8107913 3.46052174,2.46122609 C6.81086957,-0.889121739 12.3227826,-0.808513043 15.7709565,2.64044348 C16.5433913,3.41131304 17.1467826,4.28392174 17.5803478,5.2167913"
                    transform="translate(9.290244, 8.705862) scale(-1, 1) translate(-9.290244, -8.705862) "
                />
            </g>
        </svg>
    );
};

export default React.memo(Undo);
